/**
 * Entities action types
 */

export const CHART_REQUESTED = '[REPORTS] CHART REQUESTED';
export const EXPORT_SYNTHESIS_REQUESTED = '[REPORTS] EXPORT SYNTHESIS REQUESTED';
export const EXPORT_SALES_REQUESTED = '[REPORTS] EXPORT SALES REQUESTED';
